module.exports = __webpack_public_path__ + "img/logo.458f43ac.png";